import { html, unsafeCSS } from "lit";
import { customElement } from "lit/decorators.js";
import "@/components/menu-item";
import "@/components/icon";
import "@/components/shortcut";
import EkoElement from "@/utilities/element";
import style from "./command-menu-header.css?inline";
import "./command-menu-header-input.css"; // Light DOM styles

@customElement("eko-command-menu-header")
export class CommandMenuHeader extends EkoElement {
  static styles = [...EkoElement.styles, unsafeCSS(style)];

  private handleClose() {
    const menu = this.closest("eko-command-menu") as (HTMLElement & { hide(): void }) | null;
    if (menu) {
      menu.hide();
    }
  }

  render() {
    return html`
      <div class="eko-command-menu-header__input-row" part="input-row">
        <slot></slot>
        <button
          class="eko-command-menu-header__close"
          part="close"
          aria-label="Close"
          @click=${this.handleClose}>
          <eko-icon name="x-close"></eko-icon>
        </button>
      </div>
      <slot name="after"></slot>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    "eko-command-menu-header": CommandMenuHeader;
  }
}

export default CommandMenuHeader;
